import React from 'react';
import * as Images from '../../../../assets';

const GoldenLedgerContent = () => {
  return (
    <div className="max-w-6xl mt-6 mx-auto bg-white">
      {/* Header Section with Image */}
      <div className="w-full flex justify-center bg-orange-400 rounded rounded-3xl">
        <img
          src={Images.golden_ledger_img}
          alt="Golden Ledger Program Header with CA Pratik Shah, MR Paresh Rajpara, and CA Meet Jadavala"
          className="w-full max-w-6xl h-auto block object-cover rounded rounded-3xl"
        />
      </div>

      {/* Title Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-orange-500 text-sm font-medium mb-4">Trusted by 500+ Jewellery Businesses</p>

          <p className="text-5xl tracking-widest font-extrabold text-orange-500 mb-4 md:text-4xl sm:text-3xl">
            THE GOLDEN LEDGER
          </p>

          <h2 className="text-2xl font-bold text-gray-700 mb-6 leading-tight sm:text-xl">
            Tax-Smart Accounting & Audit-Ready System <br /> for
            Modern Jewellers
          </h2>

          <p className="text-gray-600 text-md mb-8 leading-relaxed max-w-3xl mx-auto">
            <span className='font-bold text-orange-500'>Headway Business Solutions LLP</span> brings you <span className='font-bold text-orange-500'>"The Golden Ledger"</span> — India's first
            Jewellery Accounting & Audit Discipline Coaching Program that blends Business
            Wisdom, Legal Compliance, and Systemised Training.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdAPkycve1LQbwhJ_jGqntzYpj44iOcS9T--RSQtcFt_26tUA/viewform", "_blank")} className="bg-orange-500 text-white px-4 py-2 rounded-lg text-lg font-semibold hover:bg-orange-600 transition-colors">
              RESERVE YOUR SEAT
            </button>
            {/* <button className="border-2 border-orange-500 text-orange-500 px-4 py-2 rounded-lg text-lg font-semibold hover:bg-orange-50 transition-colors">
              Talk to Expert Now
            </button> */}
          </div>

          <div className="mt-6 flex items-center justify-center text-gray-500 text-sm">
            <span className="mr-2">🔒</span>
            <span>100% Satisfaction Guarantee</span>
          </div>
        </div>
      </section>

      {/* Who Can Enroll Section */}
      <section className="py-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-600 mb-8">Who Can Enroll For This Coaching Program</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-orange-50 p-6 rounded-lg text-center shadow-sm">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-blue-500">🏪</span>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Jewellery Store Owners</h3>
              {/* <p className="text-sm text-gray-600">Looking to streamline operations and stop tax leakage.</p> */}
            </div>

            <div className="bg-orange-50 p-6 rounded-lg text-center shadow-sm">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-green-500">🧮</span>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Accounting & Finance Heads</h3>
              {/* <p className="text-sm text-gray-600">Managing stock transfers and consolidated books.</p> */}
            </div>

            <div className="bg-orange-50 p-6 rounded-lg text-center shadow-sm">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-green-500">🏢</span>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Multi-Branch Operators</h3>
              {/* <p className="text-sm text-gray-600">Managing stock transfers and consolidated books.</p> */}
            </div>

            <div className="bg-orange-50 p-6 rounded-lg text-center shadow-sm">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-purple-500">👨‍👩‍👧‍👦</span>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Family Business Owners</h3>
              {/* <p className="text-sm text-gray-600">Securing the legacy with clean, transparent books.</p> */}
            </div>
          </div>
        </div>
      </section>

      {/* Reality Check & Solution Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid lg:grid-cols-1 gap-12 ">
            {/* Left Side - Reality Check */}
            <div className="bg-orange-50 p-8 rounded-lg shadow shadow-lg">
              <div className="mb-6 ml-8">
                <span className="text-red-600 bg-red-100 p-1 rounded text-sm font-semibold uppercase tracking-wide">THE REALITY CHECK</span>
                <h2 className="text-3xl font-medium text-gray-700 mt-2 leading-tight">
                  Are Hidden Accounting Errors Eating Your Profits?
                </h2>
              </div>

              <p className="text-gray-600 mb-8 ml-8 leading-relaxed">
                Most jewellers discover the cost of bad accounting only when an audit notice arrives. By then, it's often too late.
              </p>

              <div className="space-y-4 grid grid-cols-2 ml-8 max-lg:grid-cols-1">
                <div className="flex items-center">
                  <span className="text-red-500 text-xl mr-3">❌</span>
                  <span className="text-gray-700">Wrong Stock Valuation</span>
                </div>
                <div className="flex items-center">
                  <span className="text-yellow-500 text-xl mr-3">⚠️</span>
                  <span className="text-gray-700">Old Gold Mismatch</span>
                </div>
                <div className="flex items-center">
                  <span className="text-gray-500 text-xl mr-3">💸</span>
                  <span className="text-gray-700">Capital Gains Errors</span>
                </div>
                <div className="flex items-center">
                  <span className="text-blue-500 text-xl mr-3">📋</span>
                  <span className="text-gray-700">Audit Objections</span>
                </div>
                <div className="flex items-center">
                  <span className="text-green-600 text-xl mr-3">💰</span>
                  <span className="text-gray-700">Unplanned Tax Burden</span>
                </div>
              </div>
            </div>

            {/* Right Side - Golden Ledger Solution */}
            <div className="bg-orange-50 text-black p-8 rounded-lg">
              <h2 className="text-3xl font-medium mb-8">The Golden Ledger Solution</h2>

              <div className="grid grid-cols-2 max-md:grid-cols-1 gap-x-6 gap-y-4 mb-4">
                {/* Left Column */}
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">100% Audit-Ready Accounting System</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Capital Gains Tax Planning & Protection</span>
                </div>

                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Cost Valuation (WAC or FIFO Method) & NRV Compliance</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Category-Wise Jewellery Stock Control</span>
                </div>

                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Old Gold, Melting & Wastage Discipline</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Owner-Level Financial Intelligence</span>
                </div>

                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Gold Saving Schemes – Legal & Compliance Framework</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">GST Compliance for Jewellery Businesses</span>
                </div>

                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Key Income-Tax Scrutiny Triggers for Jewellers</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Ensuring Smooth & Timely Scrutiny Closure</span>
                </div>

                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Advanced Tax Planning Strategies</span>
                </div>
                <div className="flex items-start">
                  <span className="text-black text-lg mr-3 mt-1">✓</span>
                  <span className="text-black">Stress-Free March Closing – Every Year</span>
                </div>
              </div>

              {/* Last Point Centered */}
              <div className="flex items-start justify-center max-md:justify-start">
                <span className="text-black text-lg mr-3 mt-1">✓</span>
                <span className="text-black">IPO Process & Readiness for Jewellers</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Will Master Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-600 mb-4">What You Will Master</h2>
            <p className="text-gray-500 text-lg">Walk away with a tangible system you can implement immediately</p>
          </div>

          <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6">
            {/* First Row - 3 Cards */}
            <div className="bg-orange-50 p-8 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-500 text-xl">🛡️</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Audit-Ready System</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Never stress about an audit again. Your books will be organized, clear & flawless.
              </p>
            </div>

            <div className="bg-orange-50 p-8 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-500 text-xl">🔒</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Capital Gains Protection</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Smart planning to legally minimize capital gains tax liability.
              </p>
            </div>

            <div className="bg-orange-50 p-8 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-500 text-xl">💎</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Jewellery Valuation</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Master the art of specific identification and valuation systems.
              </p>
            </div>
          </div>

          {/* Second Row - 2 Cards Centered */}
          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto mt-6">
            <div className="bg-orange-50 p-8 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-500 text-xl">📊</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Lower of Cost or NRV</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Apply the "Lower of Cost or Net Realizable Value" rule correctly.
              </p>
            </div>

            <div className="bg-orange-50 p-8 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-500 text-xl">⚖️</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">WAC & Rate Control</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Handle weighted average cost and rate differences like a professional.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Team Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-orange-500 text-sm font-medium uppercase tracking-wide mb-2">PROGRAM LED BY INDUSTRY EXPERTS</p>
            <h2 className="text-3xl font-bold text-gray-700 mb-4">Learn Directly From India's Leading Jewellery Business Authorities</h2>
            {/* <p className="text-gray-600 max-w-3xl mx-auto">
              Combining real-world experience, technical mastery, and regulatory insight to help you build a thriving business.
            </p> */}
          </div>

          {/* Main Expert - Mr. Paresh Rajpara */}
          <div className="bg-white rounded-lg p-8 mb-8 shadow-sm">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="relative">
                <div className="bg-orange-100 rounded-lg pt-6 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-20 h-20 bg-orange-500 rounded-bl-full"></div>
                  <div className="w-full h-100 bg-orange-100 rounded-lg flex items-center justify-center">
                    <img
                      src={Images.GL_CM}
                      alt="Mr. Paresh Rajpara"
                      className="w-100 h-100 object-cover"
                    />
                  </div>
                </div>
              </div>

              <div>
                <div className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
                  Master Coach
                </div>
                <h3 className="text-3xl font-bold text-gray-800 mb-2">Mr. Paresh Rajpara</h3>
                <p className="text-gray-600 mb-6">Founder - Headway Business Solutions LLP</p>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center">
                    <span className="text-orange-500 mr-2">👔</span>
                    <span className="text-sm text-gray-600">30+ Years Experience</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-orange-500 mr-2">👥</span>
                    <span className="text-sm text-gray-600">2300+ Jewellers Guided</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-orange-500 mr-2">🚀</span>
                    <span className="text-sm text-gray-600">450+ Startups Developed</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-orange-500 mr-2">📚</span>
                    <span className="text-sm text-gray-600">Author of "Business a Geeta"</span>
                  </div>
                </div>

                <div className="inline-block bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-medium">
                  🏆 Creator of Jewellery Business Growth System
                </div>
              </div>
            </div>
          </div>

          {/* Technical Experts */}
          <div className="grid lg:grid-cols-2 gap-8 mb-8">
            {/* CA Pratik Shah */}
            <div className="bg-orange-100 p-6 rounded-lg shadow-sm bg-blue-100">
              <div className="flex items-start mb-4">
                <div className="w-20 h-24 bg-gray-200 mr-4 flex items-center justify-center">
                  <img
                    src={Images.GL_CA}
                    alt="CA Pratik Shah"
                    className="w-full h-full"
                  />
                </div>
                <div>
                  <div className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-medium mb-2">
                    Technical Expert
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">CA Pratik Shah</h3>
                  <p className="text-gray-600 text-sm">Income Tax & Audit Specialist</p>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Capital Gains Tax Planning</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Audit Structuring & Readiness</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Scrutiny Assessment Handling</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>IPO Advisory & Process Support</span>
                </div>
              </div>
            </div>

            {/* CA Meet Jadawala */}
            <div className="bg-orange-100 p-6 rounded-lg shadow-sm">
              <div className="flex items-start mb-4">
                <div className="w-20 h-24 bg-gray-200 mr-4 flex items-center justify-center">
                  <img
                    src={Images.GL_TA}
                    alt="CA Pratik Shah"
                    className="w-full h-full"
                  />
                </div>
                <div>
                  <div className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-medium mb-2">
                    Technical Expert
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">Mr. Meet Jadawala</h3>
                  <p className="text-gray-600 text-sm">GST Specialist for Jewellery</p>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Jewellery-Specific GST Laws</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>GST Litigation & Compliance</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Handling GST Searches</span>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="text-blue-500 mr-2">✓</span>
                  <span>Departmental Audits</span>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Guidance & Knowledge Support */}
          <div className="bg-white p-6 rounded-lg shadow-sm mb-8">
            <div className="flex items-center mb-6">
              <span className="text-gray-600 mr-2">📋</span>
              <h3 className="text-xl font-semibold text-gray-800">Additional Guidance & Knowledge Support</h3>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-6 text-center">
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">🏛️</span>
                </div>
                <p className="text-sm text-gray-600">Income Tax Officer</p>
              </div>
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">🏅</span>
                </div>
                <p className="text-sm text-gray-600">BIS Officer</p>
              </div>
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">⚖️</span>
                </div>
                <p className="text-sm text-gray-600">Legal Advocate</p>
              </div>
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">📄</span>
                </div>
                <p className="text-sm text-gray-600">Licensing Advisor</p>
              </div>
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">📊</span>
                </div>
                <p className="text-sm text-gray-600">Trade Executive</p>
              </div>
              <div className='bg-orange-100 p-2 rounded'>
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto">
                  <span className="text-gray-600 text-3xl">💼</span>
                </div>
                <p className="text-sm text-gray-600">Financial Consultant</p>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-orange-500 text-white p-8 rounded-lg">
            <div className="flex max-lg:flex-col items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center mb-4">
                  <span className="text-white mr-2">⚡</span>
                  <h3 className="text-2xl font-bold">Why This Matters</h3>
                </div>
                <p className="text-white/90 leading-relaxed">
                  The combined expertise of industry veterans, technical specialists, and regulatory authorities ensures that every participant learns how to build a legally compliant, audit-proof, and growth-ready jewellery business.
                </p>
              </div>
              <div className="ml-8 max-lg:mt-4 flex gap-4 items-center justify-center">
                <div className="bg-white/80 px-4 py-2 rounded-lg">
                  <div className="flex items-center text-white">
                    <span className="mr-2">🛡️</span>
                    <span className="text-sm text-black font-medium">Audit-Proof</span>
                  </div>
                </div>
                <div className="bg-white/80 px-4 py-2 rounded-lg">
                  <div className="flex items-center text-white">
                    <span className="mr-2">✅</span>
                    <span className="text-sm text-black font-medium">Compliance-Ready</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program Details Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              📅 36 HOURS INTENSIVE
            </div>
            <h2 className="text-4xl font-bold text-gray-700 mb-4">Then Golden Ledger</h2>
            <p className="text-xl text-gray-600 mb-2">Not an Expense — It's Your Business Protection Plan.</p>
            <p className="text-gray-500 max-w-2xl mx-auto">
              A comprehensive, hands-on certification program designed to make jewellery businesses <br /> audit-ready, tax-safe, and valuation-accurate.
            </p>
          </div>

          <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6 mb-12">
            {/* First Row - 3 Cards */}
            {/* Program Duration */}
            <div className="bg-orange-50 p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-orange-500">⏰</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">Program Duration</h3>
              </div>

              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Time</span>
                  <span className="font-semibold">36 Hours</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Schedule</span>
                  <span className="font-semibold">5 Days</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Structure</span>
                  <span className="font-semibold">10 Modules × 4 Hours</span>
                </div>
              </div>
            </div>

            {/* Daily Schedule */}
            <div className="bg-orange-50 p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-orange-500">📅</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">Daily Schedule</h3>
              </div>

              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Morning Session</span>
                  <span className="font-semibold">10:00 AM - 02:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Lunch Break</span>
                  <span className="font-semibold">02:00 PM - 03:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Afternoon Session</span>
                  <span className="font-semibold">03:00 PM - 07:00 PM</span>
                </div>
              </div>
            </div>

            {/* Workshop Format */}
            <div className="bg-orange-50 p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-orange-500">🎯</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">Workshop Format</h3>
              </div>

              <div className="space-y-3">
                <div className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span className="text-gray-600">Practical, Hands-on Workshops</span>
                </div>
                <div className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span className="text-gray-600">Real-Life Case Study Coaching</span>
                </div>
                <div className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span className="text-gray-600">Complete Program Blueprint</span>
                </div>
                <div className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span className="text-gray-600">Ready-to-use Formats & Checklists</span>
                </div>
              </div>
            </div>
          </div>

          {/* Second Row - 2 Cards Centered */}
          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
            {/* Premium Inclusions */}
            <div className="bg-orange-50 p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-orange-500">🏨</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">Premium Inclusions</h3>
              </div>

              <div className="space-y-3">
                <div className="flex items-center">
                  <span className="text-gray-400 mr-3">🏨</span>
                  <span className="text-gray-600">2 Nights Five-Star Accommodation</span>
                </div>
                <div className="flex items-center">
                  <span className="text-gray-400 mr-3">🍽️</span>
                  <span className="text-gray-600">All Meals: Breakfast, Lunch, High Tea & Dinner</span>
                </div>
                <div className="flex items-center">
                  <span className="text-gray-400 mr-3">👥</span>
                  <span className="text-gray-600">One Day On-Store Staff Training</span>
                </div>
              </div>
            </div>

            {/* Certification & Location */}
            <div className="bg-orange-50 p-6 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-orange-500">🎓</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">Certification & Location</h3>
              </div>

              <div className="space-y-3">
                <div>
                  <div className="text-orange-600 font-semibold">Headway Certified Jeweller</div>
                  <div className="text-sm text-yellow-800">Audit-Ready Status</div>
                </div>
                <div className="pt-2 border-t border-gray-100">
                  <div className="flex items-center">
                    <span className="text-gray-400 mr-3">📍</span>
                    <div>
                      <div className="font-medium text-gray-800">Ahmedabad</div>
                      <div className="text-sm text-gray-600">Venue TBC by Headway Business Solutions</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Investment */}
          <div className="max-w-6xl mx-auto">
            <div className="bg-white border-2 border-orange-400 rounded-lg p-8 text-center">
              <div className="flex items-center justify-center mb-4">
                <span className="text-orange-500 mr-2">💰</span>
                <h3 className="text-2xl font-semibold text-gray-800">Total Investment</h3>
              </div>

              <div className="mb-6">
                <div className="text-5xl font-bold text-orange-600 mb-2 ml-3">₹1,25,100</div>
                <div className="text-gray-800 font-bold">+ GST</div>
                <p className="text-md font-bold text-gray-600 mt-2">Includes All Training Materials, Facilities & Certifications</p>
              </div>

              <button onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdAPkycve1LQbwhJ_jGqntzYpj44iOcS9T--RSQtcFt_26tUA/viewform", "_blank")} className="bg-orange-500 ml-5 text-white px-8 py-2 rounded-lg text-xl font-semibold hover:bg-orange-600 transition-colors">
                RESERVE YOUR SEAT
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      {/* <section className="py-16 bg-orange-500 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">"Headway's The Golden Ledger converts accounting fear into financial confidence."</h2>

          <div className="space-y-4 mb-8">
            <p className="text-xl">"Purity is not only in gold – it must also shine in your books."</p>
            <p className="text-xl">"Audit fear doesn't end with a CA; it ends with a system."</p>
          </div>

          <p className="text-lg mb-2">Headway's system helps jewellers build that inner discipline —</p>
          <p className="text-lg mb-6">the clarity to grow without fear, and the confidence to face audits with pride.</p>

          <div className="bg-white text-orange-500 p-6 rounded-lg inline-block mb-8">
            <p className="text-2xl font-bold">The Golden Ledger is not an expense — it's your business protection plan investment.</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button className="bg-white text-orange-500 px-12 py-4 rounded-lg text-xl font-semibold hover:bg-gray-100 transition-colors">
              Register Now
            </button>
            <button className="border-2 border-white text-white px-12 py-4 rounded-lg text-xl font-semibold hover:bg-white hover:text-orange-500 transition-colors">
              Talk to Expert
            </button>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default GoldenLedgerContent;